import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Icons from "../../Config/Images";
import { getLoggedInUserDetailsAPI } from "../../Store/Action/UserAction";
import Colors from "../../theme/Colors";
import Fonts from "../../Config/Fonts";

const TopNavBar = ({leftSideText,isDashboard}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const { userData } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getLoggedInUserDetailsAPI({}));
  }, [dispatch]);

  // const handleLogoutFunctionality = async () => {
  //   try {
  //     await dispatch(
  //       logOutUserAPI({}, (isSuccess, response) => {
  //         setLogoutModalOpen(false);
  //         if (isSuccess?.status === 200) {
  //           dispatch(logout())
  //           toast.success(response?.data?.message);
  //           navigate('/login')
  //         } else {
  //           const errorMessage =
  //             response?.error?.message || Strings.somethingWentWrongError;
  //           toast.error(errorMessage);
  //         }
  //       })
  //     );
  //   } catch (error) {
  //     toast.error(Strings.somethingWentWrongError);
  //   }
  // };

  // const handleLogoutClick = () => {
  //   setLogoutModalOpen(true);
  // };

  // const handleCloseModal = () => {
  //   setLogoutModalOpen(false);
  // };

  return (
    <div style={mainContainerStyle}>
      <div style={{ marginLeft: "2rem", alignItems: "center", display: "flex" }}>

      <span style={headingTxtStyle}>{leftSideText}</span>
        {isDashboard &&  <img src={Icons.waveIcon} style={waveIconStyle} alt="waveIcon" />}
      </div>

      <div style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
        <img
          src={Icons.placeholderIcon}
          alt="profileImage"
          style={profileImgStyle}
        />
      </div>
    </div>
  );
};

const mainContainerStyle = {
  display: "flex",
  width: "100%",
  height: "9vh",
  justifyContent: "space-between",
  alignItems: "center",
  // backgroundColor: Colors.white,
  backgroundColor: "#ffffff",
  marginBottom: "5px",
  position: "sticky",
  top: 0,
  // left: "20.1%",
};

const headingTxtStyle = {
  fontSize: 24,
  fontWeight: "600",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
};

const waveIconStyle = {
  height: 30,
  width: 30,
  marginLeft: 8,
};

const profileImgStyle = {
  height: "50px",
  width: "50px",
  marginRight: "10px",
};

export default TopNavBar;
